// extracted by mini-css-extract-plugin
export default {"switch":"toggle-switch_switch__9hUjH","slider":"toggle-switch_slider__d9L73"};